import classes from "./Statuses.module.css";
export default function Statuses({
  status,
  isLabel = true,
  variant = "light",
}) {
  const statusesColor = {
    light: {
      active: {
        bgColor: "transparent",
        color: "rgb(17 162 96)",
        label: "Active",
      },
      "low-stock": {
        bgColor: "#FDF1E8",
        color: "#E46A11",
        label: "Low Stock",
      },
      published: {
        bgColor: "#E7F4EE",
        color: "#0D894F",
        label: "Published",
      },
      draft: {
        bgColor: "#E5E7EB",
        color: "#667085",
        label: "Draft",
      },
      "out-of-stock": {
        bgColor: "#FEEDEC",
        color: "#F04438",
        label: "Out of Stock",
      },
      pending: {
        bgColor: "transparent",
        color: "#FEE300",
        label: "Pending",
      },
      blocked: {
        bgColor: "transparent",
        color: "#FF0000",
        label: "Blocked",
      },
      "system-deactivated": {
        bgColor: "transparent",
        color: "#FF0000",
        label: "Inactive",
      },
      "incomplete-profile": {
        bgColor: "transparent",
        color: "#FEE300",
        label: "Incomplete Profile",
      },
      cancelled: {
        bgColor: "#FEEDEC",
        color: "#F04438",
        label: "Cancelled",
      },
      delivered: {
        bgColor: "#E7F4EE",
        color: "#0D894F",
        label: "Delivered",
      },
      "in-progress": {
        bgColor: "#FFF8E1",
        color: "#DDAA00",
        label: "In Progress",
      },
      "payment-completed": {
        bgColor: "#E7F4EE",
        color: "#0D894F",
        label: "Payment Completed",
      },
      "payment-failed": {
        bgColor: "#FEEDEC",
        color: "#F04438",
        label: "Payment Failed",
      },
      "payment-pending": {
        bgColor: "#FFF8E1",
        color: "#DDAA00",
        label: "Payment Pending",
      },
    },
    solid: {
      approved: {
        bgColor: "#1F9560",
        color: "#ffffff",
        label: "Approved",
      },
      rejected: {
        bgColor: "#BE0000",
        color: "#ffffff",
        label: "Rejected",
      },
      pending: {
        bgColor: "linear-gradient(0deg, #D7AC00 0%, #D7AC00 100%), #FFF",
        color: "#ffffff",
        label: "Pending",
      },
      "system-deactivated": {
        bgColor: "#BE0000",
        color: "#ffffff",
        label: "System Deactivated",
      },
      "incomplete-profile": {
        bgColor: "linear-gradient(0deg, #D7AC00 0%, #D7AC00 100%), #FFF",
        color: "#ffffff",

        label: "Incomplete Profile",
      },
      "payment-completed": {
        bgColor: "#E7F4EE",
        color: "#0D894F",
        label: "Payment Completed",
      },
      "payment-failed": {
        bgColor: "#FEEDEC",
        color: "#F04438",
        label: "Payment Failed",
      },
      "payment-pending": {
        bgColor: "#FFF8E1",
        color: "#DDAA00",
        label: "Payment Pending",
      },
    },
  };
  return (
    <div
      className={`${classes.statusWrapper} ${
        !isLabel ? classes.withoutLabel : ""
      } ${variant === "solid" ? classes.solid : ""}`}
      style={{ background: statusesColor[variant][status]?.bgColor }}
    >
      {isLabel && (
        <p style={{ color: statusesColor[variant][status]?.color }}>
          {statusesColor[variant][status]?.label}
        </p>
      )}
    </div>
  );
}
